import { graphql } from "gql";

const INTERNAL_ADMIN_ORGANIZATION_LIST_QUERY = graphql(`
  query InternalAdminOrganizationList(
    $input: InternalAdminOrganizationListInput!
  ) {
    internalAdminOrganizationList(input: $input) {
      ...InternalAdminOrganization
    }
  }
`);

export default INTERNAL_ADMIN_ORGANIZATION_LIST_QUERY;
